import slugify from "slugify";

export default class StringHelper {
  /**
   * @summary Slugify a string removing all whitespace in exchange for '_'.
   * !! Also removes most special chars especially slashes as they cause untold headaches...
   * @param stringValue
   */
  static Slugify(stringValue: string): string {
    // * Slugify the name ---------------------------------------------------
    return slugify(stringValue, {
      replacement: "_",
      // eslint-disable-next-line no-useless-escape
      remove: /[`~!@#$%^&()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g,
      lower: true,
    });
  }
  static CheckPasswordComplexity(password: string): boolean {
    return new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{12,})"
    ).test(password);
  }
}
